import { render, staticRenderFns } from "./AdsSearch.vue?vue&type=template&id=a35d4314&"
import script from "./AdsSearch.vue?vue&type=script&lang=js&"
export * from "./AdsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports